module.exports = __webpack_public_path__ + "static/media/archive.8c02ff1c.svg";